import React from 'react';
import rubel from '../../assets/rubel2.jpeg';
import Experience from '../Experience/Experience';

const About = () => {
  const handleScroll = () => {
    const hash = '#contact';
    const el = document.querySelector(hash);
    const offsetTop = el.offsetTop;
    if (typeof window !== `undefined`) {
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="about" className="pb-10 mt-2 md:mt-0 container mx-auto">
      <div className="flex justify-center">
        <h2 className="text-white mb-5 md:mb-0 font-extrabold text-4xl relative z-20  ">
          ABOUT ME.
        </h2>
        <svg
          class="absolute mt-[20px]"
          width="175"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="pathItem"
            d="M5 20 Q 70 0 150 20"
            stroke="#E12457"
            fill="transparent"
            stroke-width="7"
            stroke-linecap="round"
          ></path>
        </svg>
      </div>
      <div className="grid md:grid-cols-2">
        <div className="flex justify-center items-center ">
          <img
            src={rubel}
            alt="Parvez Hasan Rubel"
            style={{ boxShadow: '12px 10px #e12457' }}
            className=" w-80 h-80 rounded-lg grayscale hover:grayscale-0 duration-1000 hover:scale-105 hover:shadow-primary hover:shadow-xl"
          />
        </div>
        <div className="px-5 md:px-10 my-10">
          <p className="text-white text-base text-justify justify-center md:justify-start">
            I’m a passionate software developer with a strong focus on building
            scalable, high-performance applications using JavaScript, Go
            (Golang), and React Native. I build fast, scalable web applications
            using JavaScript (React) and Go (Golang) for the backend. I also
            develop high-performance, concurrent web services and APIs with Go.
            I also build mobile applications that run on both iOS and Android
            using React Native. I specialize in creating responsive,
            user-friendly web interfaces with React. Driven by clean code,
            problem-solving, and continuous learning, I’m always exploring new
            tools and best practices to write maintainable and efficient
            software. Whether I’m collaborating with teams or working
            independently, I bring a deep sense of responsibility and creativity
            to every project.
          </p>
          <div className="flex justify-center md:justify-start gap-4 mt-5 text-white text-base ">
            <a
              href="https://drive.google.com/uc?export=download&id=1lXcKZSC3WNBqShs_67VcqaXY7q_Fe7OS"
              className=" border-primary border-2 px-7 py-2 "
            >
              Resume
            </a>
            <button
              onClick={handleScroll}
              className="border-2 border-primary px-7 py-2"
            >
              Contact Me
            </button>
          </div>
        </div>
      </div>
      <Experience />
    </section>
  );
};

export default About;
